import { render } from "./EmailSent.vue?vue&type=template&id=179633ec&scoped=true"
import script from "./EmailSent.vue?vue&type=script&lang=js"
export * from "./EmailSent.vue?vue&type=script&lang=js"

import "./EmailSent.vue?vue&type=style&index=0&id=179633ec&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-179633ec"]])

export default __exports__